import { Component } from '@angular/core'
import { Observable } from 'rxjs'
import { EbOrder } from '../../interfaces/eb-order.interface'
import { EbOrderHistoryService } from '../../services/facades/eb-order-history.service'

@Component({
    selector: 'eb-order-detail-documents',
    templateUrl: './eb-order-detail-documents.component.html',
    styleUrls: ['./eb-order-detail-documents.component.scss'],
    standalone: false
})
export class EbOrderDetailDocumentsComponent {
  order$: Observable<EbOrder> = this.ebOrderHistoryService.getOrderDetails()
  dataStructure$ = this.ebOrderHistoryService.getOrderHistoryDocumentsTableStructure()

  constructor(
    private readonly ebOrderHistoryService: EbOrderHistoryService
  ) {}
}
